var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuTenants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - Tenants",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.994-6.016a1.01 1.01 0 0 1-1 1h-1l.022 5.01a2 2 0 0 1-2 2.006H-5a2 2 0 0 1-2-2v-5.012h-1a.988.988 0 0 1-1-1 1.016 1.016 0 0 1 .313-.75l8.012-6.988A.9.9 0 0 1 .012-14a1.038 1.038 0 0 1 .656.219L8.65-6.766a.856.856 0 0 1 .344.75zM2-7a2 2 0 0 0-1-1.732 2 2 0 0 0-2 0A2 2 0 0 0-2-7a2 2 0 0 0 1 1.732 2 2 0 0 0 2 0A2 2 0 0 0 2-7zm-3 3a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5A2.5 2.5 0 0 0 1-4z",
    transform: "translate(12 18)",
    style: {
      fill: "#778187"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuTenants);
export default __webpack_public_path__ + "static/media/IconMenuTenants.daacfb1d00b3d42ebb4c096a19e44bfd.svg";
export { ForwardRef as ReactComponent };